<template>
  <b-card>
    <div class="d-flex">
      <h4 class="mb-0">About Information</h4>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" v-if="aboutData.gallary_image_path" class="d-flex justify-content-center">
         
            <img
              style="width: 100%; max-width: 300px"
              :src="getImgPath(aboutData.gallary_image_path)"
            />
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col md="12">
            <b-form-group label="Banner Image" label-cols-md="3">
              <el-upload
                class="avatar-uploader"
                list-type="picture-card"
                ref="upload"
                :action="uploadUrl"
                :headers="headerObj"
                name="image_file"
                :file-list="fileList"
                multiple
                :limit="1"
                :data="aboutData"
                :on-change="onChange"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :auto-upload="false"
                :class="{ hideUpload: !showUpload }" 
              >
                <img
                  v-if="aboutData.gallary_image_path && false"
                  :src="getImgPath(aboutData.gallary_image_path)"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
        
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
              <b-form-group label="Title" label-for="gallary_main_title" label-cols-md="3">
               <b-form-input
                    id="title"
                    v-model="aboutData.title"
                  />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group label="Content" label-for="gallary_content" label-cols-md="3">
                <TinyMCEEditor :content.sync="aboutData.content" />
              </b-form-group>
            </b-col>
        </b-row>
        <!-- Form Actions -->

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>
            
          </div>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BCard,
  BCardBody,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormInvalidFeedback,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import aboutStoreModule from "./aboutStoreModule";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import TinyMCEEditor from "@/layouts/components/TinyMCEEditor.vue"
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import {getUserData} from '@/auth/utils'

import { quillEditor } from "vue-quill-editor";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    BFormInvalidFeedback,
    BOverlay,
    quillEditor,
    BFormTextarea,
    TinyMCEEditor
  },
  methods: {
    toggleUpload() {
        this.showUpload = !this.showUpload
      },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure you want to save?",
        showCancelButton: true,
        
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData()
          
          formData.append('store_id', getUserData().store_id)

          if(this.aboutData.file) {
            formData.append('file', this.aboutData.file)
          }else{
            formData.append('file', "")
          }

          formData.append('id', this.aboutData.id || 0)

          if(this.aboutData.title){
            formData.append('title', this.aboutData.title)
          }else{
            formData.append('title', "")
          }

          if(this.aboutData.content){
            formData.append('content', this.aboutData.content)
          }else{
            formData.append('content', "")
          }
          
          this.loading = true
          store
            .dispatch("about/updateAbout", formData)
            .then((response) => {
              this.loading = false
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              })
              this.refetchData()
            })
            .catch((error) => {
              this.loading = false
              this.$swal({
                text: error.response.data.message,
                icon: "error", 
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              })
            })
        }
      })
    },
    handleRemove() {
      this.showUpload = true
      this.aboutData.file = null
      this.aboutData.gallary_image_path = null
    },
    
    beforeRemove() {
  /*     return new Promise((resolve) => {
        this.$swal({
          title: 'Are you sure you want to delete this image?',
          text: 'You will need to submit a new picture.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          resolve(result.value)
        })
      }) */
    },
  },
  setup() {
    const loading = ref(false)
    const isHtmlMode = ref(true)
    const fileList = ref([])
    const aboutData = ref({
      id: 0,
      title: '',
      content: '',
      file: null,
      gallary_image_path: null
    })
    const showUpload = ref(true)

    // 注册 store module
    if (!store.hasModule('about')) {
      store.registerModule('about', aboutStoreModule)
    }

    // 组件卸载时注销 module
    onUnmounted(() => {
      if (store.hasModule('about')) {
        store.unregisterModule('about')
      }
    })

    // 获取初始数据
    const refetchData = () => {
      loading.value = true
      store.dispatch('about/fetchAbout', {store_id: getUserData().store_id})
        .then((response) => {
          const about = response.data.about
          if (about) {
            aboutData.value = {
              id: about.id,
              title: about.title,
              content: about.content,
              gallary_image_path: about.image_path
            }
          }
        })
        .catch(error => {
          console.error('获取数据失败:', error)
        })
        .finally(() => {
          loading.value = false
        })
    }

    onMounted(() => {
      refetchData()
    })

    // 文件改变处理
    const onChange = (file) => {
      if (file) {
        showUpload.value = !showUpload.value
        aboutData.value.file = file.raw
      }
    }

    return {
      loading,
      isHtmlMode,
      fileList,
      aboutData,
      onChange,
      refetchData,
      showUpload,
      uploadUrl: process.env.VUE_APP_SERVICE_URL + '/about',
      headerObj: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken')
      }
    }
  },
};
</script>

<style lang="scss">

</style>